import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { interval: { type: Number, default: 30000 } };

  connect() {
    this.timer = setInterval(() => this.reload(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  reload() {
    const frame = this.element.querySelector("turbo-frame[src]");
    if (frame) frame.reload();
  }
}
